
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
:host {
  display: inline-block;
  width: 100%;
  position: relative;
}
:host .label-wrapper {
  font-family: var(--slh-default-font-family, "Open Sans");
}
:host > .datepicker-input-wrapper {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  align-items: center;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 12px;
  padding-bottom: 12px;
  background-color: var(--slh-color-neutral-shade-00, #FFFFFF);
  border: 2px solid var(--slh-color-neutral-shade-20, #EBEEF4);
  box-sizing: border-box;
  border-radius: 8px;
  height: 48px;
  outline: none;
}
:host > .datepicker-input-wrapper .icon-wrapper {
  fill: var(--slh-color-neutral-shade-60, #62779F);
}
:host > .datepicker-input-wrapper input {
  width: 100%;
  font-family: var(--slh-default-font-family, "Open Sans");
  font-size: var(--slh-base-xs-font-size, 14px);
  font-style: normal;
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  line-height: var(--slh-base-xxs-line-height, 24px);
  color: var(--slh-color-neutral-shade-60, #62779F);
  border: 0;
  outline: none;
  padding: 0;
  background-color: var(--slh-color-neutral-shade-00, #FFFFFF);
}
:host > .datepicker-input-wrapper input::placeholder {
  color: var(--slh-color-neutral-shade-40, #C0C8D8);
}
:host > .datepicker-input-wrapper:hover:not(.focused, [disabled], [error]) {
  color: var(--slh-color-neutral, #39455D);
  background-color: var(--slh-color-neutral-shade-00, #FFFFFF);
  border: 2px solid var(--slh-color-neutral-shade-40, #C0C8D8);
}
:host > .datepicker-input-wrapper:hover:not(.focused, [disabled], [error]) input {
  color: var(--slh-color-neutral, #39455D);
  background-color: var(--slh-color-neutral-shade-00, #FFFFFF);
}
:host > .datepicker-input-wrapper:hover:not(.focused, [disabled], [error]) input::placeholder {
  color: var(--slh-color-neutral, #39455D);
}
:host > .datepicker-input-wrapper:active:not([disabled], [error]), :host > .datepicker-input-wrapper.active:not([disabled], [error]), :host > .datepicker-input-wrapper:focus-within:not([disabled], [error]), :host > .datepicker-input-wrapper.focused {
  border: 2px solid var(--slh-color-primary-shade-60, #89B7E5);
  background-color: var(--slh-color-primary-shade-20, #ECF3FB);
}
:host > .datepicker-input-wrapper:active:not([disabled], [error]) input, :host > .datepicker-input-wrapper.active:not([disabled], [error]) input, :host > .datepicker-input-wrapper:focus-within:not([disabled], [error]) input, :host > .datepicker-input-wrapper.focused input {
  background-color: var(--slh-color-primary-shade-20, #ECF3FB);
}
:host > .datepicker-input-wrapper:active:not([disabled], [error]) input::placeholder, :host > .datepicker-input-wrapper.active:not([disabled], [error]) input::placeholder, :host > .datepicker-input-wrapper:focus-within:not([disabled], [error]) input::placeholder, :host > .datepicker-input-wrapper.focused input::placeholder {
  color: var(--slh-color-neutral, #39455D);
}
:host > .datepicker-input-wrapper[error] {
  border: 2px solid var(--slh-color-error-shade-60, #FFB6AD);
  background-color: var(--slh-color-error-shade-20, #FFEDEB);
}
:host > .datepicker-input-wrapper[error]:hover input,
:host > .datepicker-input-wrapper[error] input {
  color: var(--slh-color-neutral, #39455D);
  background-color: var(--slh-color-error-shade-20, #FFEDEB);
}
:host > .datepicker-input-wrapper[error]:hover input::placeholder,
:host > .datepicker-input-wrapper[error] input::placeholder {
  color: var(--slh-color-neutral, #39455D);
}
:host > .datepicker-input-wrapper[error] slot:not([name])::slotted(*) {
  color: var(--slh-color-neutral, #39455D);
}
:host > .datepicker-input-wrapper[error]:hover {
  border: 2px solid var(--slh-color-error-shade-80, #FFA399);
}
:host > .datepicker-input-wrapper[error].focused, :host > .datepicker-input-wrapper[error]:active {
  filter: drop-shadow(0px 2px 2px var(--slh-color-error-shade-40, #FFDBD6));
  -webkit-filter: drop-shadow(0px 2px 2px var(--slh-color-error-shade-40, #FFDBD6));
}
:host > .datepicker-input-wrapper[readonly] {
  background-color: var(--slh-color-neutral-shade-10, #F6F7FA);
}
:host > .datepicker-input-wrapper[readonly] input {
  color: var(--slh-color-neutral-shade-40, #C0C8D8);
  background-color: var(--slh-color-neutral-shade-10, #F6F7FA);
}
:host > .datepicker-input-wrapper[disabled] {
  background-color: var(--slh-color-neutral-shade-10, #F6F7FA);
  cursor: not-allowed;
}
:host > .datepicker-input-wrapper[disabled] input {
  color: var(--slh-color-neutral-shade-40, #C0C8D8);
  background-color: var(--slh-color-neutral-shade-10, #F6F7FA);
}
:host > .datepicker-input-wrapper[disabled]:hover, :host > .datepicker-input-wrapper[disabled]:active {
  border-color: var(--slh-color-neutral-shade-20, #EBEEF4);
}
:host .hint-wrapper {
  display: flex;
  flex-direction: row;
  align-items: start;
}
:host .hint-wrapper .hint-icon-container {
  margin-top: 4px;
  padding-right: 4px;
  display: flex;
  flex-shrink: 0;
  flex-grow: 0;
}
:host .hint-wrapper * {
  font-family: var(--slh-default-font-family, "Open Sans");
  font-size: var(--slh-base-xxs-font-size, 12px);
  font-weight: var(--slh-base-bold-font-weight, 700);
  line-height: var(--slh-base-xxs-line-height, 24px);
  color: var(--slh-color-neutral-shade-60, #62779F);
}
:host .hint-wrapper.hidden {
  display: none;
}

:host([disabled]) {
  pointer-events: none;
}

:host([error]) ::slotted(:not([slot=hint])) {
  color: var(--slh-color-error, #FF7E70);
}

/* END datepicker input field */
/* CALENDAR */
:host .datepicker-container {
  padding: 24px;
  border-radius: 16px;
  position: absolute;
  width: 310px;
  height: 364px;
  right: 0px;
  overflow: visible;
  display: none;
  justify-content: center;
  align-items: center;
  border: unset;
  outline: none;
  box-sizing: border-box;
  text-decoration: none;
  user-select: none;
  text-transform: none;
  font-family: var(--slh-default-font-family, "Open Sans");
  background-color: var(--slh-color-neutral-shade-00, #FFFFFF);
  filter: drop-shadow(0px 8px 24px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.16)));
  -webkit-filter: drop-shadow(0px 8px 24px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.16)));
  z-index: 999;
}
:host .datepicker-container.open {
  display: block;
}
:host .datepicker-container.open-top {
  bottom: 48px;
}
:host .datepicker-container .date-holder {
  display: flex;
  margin-bottom: 24px;
}
:host .datepicker-container .date-holder .prev-month,
:host .datepicker-container .date-holder .next-month {
  cursor: pointer;
}
:host .datepicker-container .date-holder .prev-month .icon-wrapper,
:host .datepicker-container .date-holder .next-month .icon-wrapper {
  fill: var(--slh-color-neutral, #39455D);
}
:host .datepicker-container .date-holder .prev-month:hover .icon-wrapper,
:host .datepicker-container .date-holder .next-month:hover .icon-wrapper {
  fill: var(--slh-color-neutral-shade-60, #62779F);
}
:host .datepicker-container .date-holder .date {
  flex-grow: 1;
  text-align: center;
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
  font-size: var(--slh-base-m-font-size, 16px);
  font-weight: var(--slh-base-bold-font-weight, 700);
}
:host .datepicker-container #datepicker {
  width: 100%;
  margin: 0 auto;
  position: relative;
}
:host .datepicker-container #datepicker table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}
:host .datepicker-container #datepicker table .week-days {
  color: var(--slh-color-neutral-shade-60, #62779F);
  font-size: var(--slh-base-xxs-font-size, 12px);
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  text-align: center;
  text-transform: uppercase;
}
:host .datepicker-container #datepicker table .week-days td {
  padding-bottom: 16px;
}
:host .datepicker-container #datepicker table .week .day {
  width: 14.28%;
  text-align: center;
  font-size: var(--slh-base-xs-font-size, 14px);
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  line-height: var(--slh-base-xxs-line-height, 24px);
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
  cursor: pointer;
}
:host .datepicker-container #datepicker table .week .day span {
  min-width: 18px;
  padding: 6px 9px;
  display: inline-block;
  border-radius: var(--slh-base-s-line-height, 32px);
  vertical-align: middle;
  position: relative;
}
:host .datepicker-container #datepicker table .week .day span:hover,
:host .datepicker-container #datepicker table .week .day span.today {
  background: var(--slh-color-neutral-shade-20, #EBEEF4);
}
:host .datepicker-container #datepicker table .week .day:not(.other-month) span.selected {
  background: var(--slh-color-primary, #3B87D4);
  color: var(--slh-color-neutral-shade-00, #FFFFFF);
}
:host .datepicker-container #datepicker table .other-month {
  color: var(--slh-color-neutral-shade-40, #C0C8D8);
}
`;
